module.exports = ".wyniki{\r\n    width:400px; \r\n    height:auto; \r\n    margin:0px auto; \r\n    margin-left:20%;\r\n    margin-bottom:5%;\r\n    float:left;\r\n    letter-spacing: 2px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/lines/details/details.component.css
// module id = ./src/app/lines/details/details.component.css
// module chunks = main